import { styled } from '@mui/material'

export default styled('div')`
  box-shadow: var(--primaryShadow);
  padding: 30px;
  border-radius: 6px;
  width: auto;
  background-color: #fff;
`
